import { Component } from '@theme/component';

/**
 * A custom element that shows/hides subscription price based on recharge selling plan state
 */
class VariantPricePerServing extends Component {
  connectedCallback() {
    super.connectedCallback?.();
    this.#updatePriceDisplay();
  }

  updatedCallback() {
    super.updatedCallback?.();
    this.#updatePriceDisplay();
  }

  /**
   * Updates which price per serving is visible based on selling plan state
   */
  #updatePriceDisplay() {
    // Get the parent variant-content element and its selling plan ID
    const variantContent = /** @type {HTMLElement} */ (this.closest('variant-content'));
    const sellingPlanId = variantContent?.dataset.sellingPlanId;

    // Get price display elements
    const subscriptionPriceEl = /** @type {HTMLElement} */ (this.querySelector('[data-subscription]'));
    const regularPriceEl = /** @type {HTMLElement} */ (this.querySelector('[data-regular]'));

    // Only show subscription price if we have a selling plan ID and subscription price exists
    if (subscriptionPriceEl) {
      subscriptionPriceEl.hidden = !sellingPlanId;
    }

    // Show regular price if no subscription price, or always show it for comparison
    if (regularPriceEl && !sellingPlanId) {
      regularPriceEl.hidden = false;
    }
  }
}

if (!customElements.get('variant-price-per-serving')) {
  customElements.define('variant-price-per-serving', VariantPricePerServing);
}
